import { BrowserRouter, Route, Routes } from "react-router-dom";
import Footer from "./components/general/Footer";
import Header from "./components/general/Header";

import Home from "./components/pages/Home";
import About from "./components/pages/About";
import GallerySection from "./components/pages/Gallery";
import Contact from "./components/pages/Contact";
import Services from "./components/pages/Services";

function App() {
  return (
    <BrowserRouter>
      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About/>}/>
            <Route path="/gallery" element={<GallerySection/>}/>
                <Route path="/services" element={<Services/>}/>
            <Route path="/contact" element={<Contact/>}/>

        
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}

export default App;